module.exports = __webpack_public_path__ + "img/119.70b6ab24.png";